'use client';

import { QueryClientProvider as TanQueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/shared/api/query-client';

export function QueryClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <TanQueryClientProvider client={queryClient}>
      {children}
    </TanQueryClientProvider>
  );
}
